// Dependencies
import React from 'react';
import radium from "radium";
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import InlineSpinner from "../../../components/spinner/InlineSpinner";
import CheckoutButtons from "../CheckoutButtons";

interface PAYPAL_AUTH_props {
	checkoutProps: any,
	next: any,
	pop: any,
	reset: any,
	btnLabels: any
}

function PAYPAL_AUTH(props: PAYPAL_AUTH_props) {

	const context = React.useContext(ThemeContext);
	const style:any = {
		textContainer: {
			margin: '2em',
			display: 'flex',
			justifyContent: 'center',
			flexWrap: 'wrap'
		},
		inlineSpinner: {
			width: '100%',
			margin: '3em 0 0',
			height: '5em',
		},
		buttonContainer: {
			marginTop: '3em',
			marginBottom: '3em',
		},
		counterContainer: {
			width: '1.5em',
			color: context.themeManager.value('checkout', 'counter-color', 'fg-color-text-highlight'),
			textAlign: 'center',
			fontWeight: '600'
		}
	}

	const reParam = new URL(window.location.href).searchParams.get("p");

	React.useEffect(() => {
		if (!reParam) {
			window.location.href = props.checkoutProps.output.redirect
		} else if (reParam === 'paypal_cancel') {
			window.history.replaceState(null, '', window.location.pathname);
			props.pop({method: props.checkoutProps.method, provider: props.checkoutProps.provider})

		} else if (reParam === 'paypal_return') {
			window.history.replaceState(null, '', window.location.pathname);
			props.next({method: props.checkoutProps.method, provider: props.checkoutProps.provider})
		}
		// run useEffect only once --> deps have to be empty
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div>
			<div style={style.textContainer}>
				Sie werden zu PayPal weitergeleitet.
				<div style={style.inlineSpinner}>
					<InlineSpinner waitingTimeMs={2000}/>
				</div>
			</div>
			<CheckoutButtons
				btnResetLabel={props.btnLabels.resetBtnLabel}
				btnNextLabel={props.btnLabels.nextBtnLabel}
				btnBackLabel={props.btnLabels.backBtnLabel}
				onBackClick={()=>props.pop({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				onResetClick={()=>props.reset({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				hideNextButton={true}
			/>
		</div>
	);
}

const RadiumPAYPAL_AUTH = radium(PAYPAL_AUTH);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
// @ts-expect-error Cannot assign to name because it is a read-only property.
RadiumPAYPAL_AUTH["name"] = PAYPAL_AUTH.name

export default RadiumPAYPAL_AUTH;
